import { LocationType, RateType, ServiceType } from '@wix/ambassador-bookings-services-v2-service/types';
export const isCourseService = service => {
  return service.type === ServiceType.COURSE;
};
export const isAppointmentService = service => {
  return service.type === ServiceType.APPOINTMENT;
};
export const isClassService = service => {
  return service.type === ServiceType.CLASS;
};
export const isServiceBookOnlineEnabled = service => {
  var _service$onlineBookin;
  return (_service$onlineBookin = service.onlineBooking) == null ? void 0 : _service$onlineBookin.enabled;
};
export const isServiceAutoAssignResourceAllowed = service => {
  var _service$bookingPolic;
  return (_service$bookingPolic = service.bookingPolicy) == null || (_service$bookingPolic = _service$bookingPolic.resourcesPolicy) == null ? void 0 : _service$bookingPolic.autoAssignAllowed;
};
export const isServicePendingApprovalFlow = service => {
  var _service$onlineBookin2;
  return (_service$onlineBookin2 = service.onlineBooking) == null ? void 0 : _service$onlineBookin2.requireManualApproval;
};
export const isStaffMemberConnectedToService = (service, staffMemberId) => {
  var _service$staffMemberI;
  return (_service$staffMemberI = service.staffMemberIds) == null ? void 0 : _service$staffMemberI.includes(staffMemberId);
};
export const getServicePricingPlanIds = service => {
  var _service$payment;
  return (_service$payment = service.payment) == null ? void 0 : _service$payment.pricingPlanIds;
};
export const isServiceVariedPricing = service => {
  var _service$payment2;
  return (_service$payment2 = service.payment) == null ? void 0 : _service$payment2.varied;
};
export const getServiceFixedPrice = service => {
  var _service$payment3;
  return (_service$payment3 = service.payment) == null || (_service$payment3 = _service$payment3.fixed) == null || (_service$payment3 = _service$payment3.price) == null ? void 0 : _service$payment3.value;
};
export const getServiceFixedCurrency = service => {
  var _service$payment4;
  return (_service$payment4 = service.payment) == null || (_service$payment4 = _service$payment4.fixed) == null || (_service$payment4 = _service$payment4.price) == null ? void 0 : _service$payment4.currency;
};
export const getServiceMaxParticipantsPerBooking = service => {
  var _service$bookingPolic2;
  return ((_service$bookingPolic2 = service.bookingPolicy) == null || (_service$bookingPolic2 = _service$bookingPolic2.participantsPolicy) == null ? void 0 : _service$bookingPolic2.maxParticipantsPerBooking) || 1;
};
export const getServicePrice = service => {
  var _service$payment5, _service$payment$fixe, _service$payment$vari, _service$payment$cust;
  switch ((_service$payment5 = service.payment) == null ? void 0 : _service$payment5.rateType) {
    case RateType.FIXED:
      return (_service$payment$fixe = service.payment.fixed) == null || (_service$payment$fixe = _service$payment$fixe.price) == null ? void 0 : _service$payment$fixe.value;
    case RateType.VARIED:
      return (_service$payment$vari = service.payment.varied) == null || (_service$payment$vari = _service$payment$vari.defaultPrice) == null ? void 0 : _service$payment$vari.value;
    case RateType.CUSTOM:
      return (_service$payment$cust = service.payment.custom) == null ? void 0 : _service$payment$cust.description;
    case RateType.NO_FEE:
      return '0';
    default:
      return null;
  }
};
export const getServiceCurrency = service => {
  var _service$payment6, _service$payment$fixe2, _service$payment$vari2;
  switch ((_service$payment6 = service.payment) == null ? void 0 : _service$payment6.rateType) {
    case RateType.FIXED:
      return (_service$payment$fixe2 = service.payment.fixed) == null || (_service$payment$fixe2 = _service$payment$fixe2.price) == null ? void 0 : _service$payment$fixe2.currency;
    case RateType.VARIED:
      return (_service$payment$vari2 = service.payment.varied) == null || (_service$payment$vari2 = _service$payment$vari2.defaultPrice) == null ? void 0 : _service$payment$vari2.currency;
    default:
      return null;
  }
};
export const getServiceLatestBookingInMinutes = service => {
  var _service$bookingPolic3, _service$bookingPolic4;
  return (_service$bookingPolic3 = service.bookingPolicy) != null && (_service$bookingPolic3 = _service$bookingPolic3.limitLateBookingPolicy) != null && _service$bookingPolic3.enabled ? (_service$bookingPolic4 = service.bookingPolicy) == null || (_service$bookingPolic4 = _service$bookingPolic4.limitLateBookingPolicy) == null ? void 0 : _service$bookingPolic4.latestBookingInMinutes : undefined;
};
export const getServiceEarliestBookingInMinutes = service => {
  var _service$bookingPolic5, _service$bookingPolic6;
  return (_service$bookingPolic5 = service.bookingPolicy) != null && (_service$bookingPolic5 = _service$bookingPolic5.limitEarlyBookingPolicy) != null && _service$bookingPolic5.enabled ? (_service$bookingPolic6 = service.bookingPolicy) == null || (_service$bookingPolic6 = _service$bookingPolic6.limitEarlyBookingPolicy) == null ? void 0 : _service$bookingPolic6.earliestBookingInMinutes : undefined;
};
export const getServiceCategoryId = service => {
  var _service$category;
  return (_service$category = service.category) == null ? void 0 : _service$category.id;
};
export const getServiceCategoryName = service => {
  var _service$category2;
  return (_service$category2 = service.category) == null ? void 0 : _service$category2.name;
};
export const isServiceOfferedOnline = service => {
  var _service$conferencing;
  return (_service$conferencing = service.conferencing) == null ? void 0 : _service$conferencing.enabled;
};
export const isServiceWithDynamicDuration = service => {
  var _service$schedule;
  const durations = ((_service$schedule = service.schedule) == null || (_service$schedule = _service$schedule.availabilityConstraints) == null ? void 0 : _service$schedule.durations) || [];
  return service.type === ServiceType.APPOINTMENT && durations.length > 1;
};
export const isServiceWithAddOns = (service, experiments) => {
  var _service$addOnGroups;
  return experiments.enabled('specs.bookings.AddonsUOU') && !!((_service$addOnGroups = service.addOnGroups) != null && _service$addOnGroups.some(group => {
    var _group$addOnIds;
    return (_group$addOnIds = group.addOnIds) == null ? void 0 : _group$addOnIds.length;
  }));
};
export const groupServicesByCategories = services => {
  const categoryMap = new Map();
  services.forEach(service => {
    if (!service.category) {
      return;
    }
    const categoryId = service.category.id;
    const groupedServices = categoryMap.get(categoryId);
    groupedServices ? groupedServices.push(service) : categoryMap.set(categoryId, [service]);
  });
  return categoryMap;
};
export const isServiceWithMultiStaff = service => {
  var _service$staffMembers;
  return ((service == null || (_service$staffMembers = service.staffMembers) == null ? void 0 : _service$staffMembers.length) || 0) > 1;
};
export const filterNonBusinessLocations = locations => locations.filter(location => location.type === LocationType.BUSINESS);
export const isServiceWithMultiBusinessLocations = service => {
  const businessLocations = filterNonBusinessLocations((service == null ? void 0 : service.locations) || []);
  return businessLocations.length > 1;
};
export const isServiceWithVariedPrice = service => {
  var _service$payment7;
  return (service == null || (_service$payment7 = service.payment) == null ? void 0 : _service$payment7.rateType) === RateType.VARIED;
};
//# sourceMappingURL=service.js.map